export default __webpack_public_path__ + "3b3272d7f9552a0dc91d976f9d447e3c.png";